import { GetClosedCohortQuery } from "generated-graphql/graphql";
import { ColoradoSummary } from "./ColoradoSummary";
import { KansasSummary } from "./KansasSummary";
import { NewMexicoSummary } from "./NewMexicoSummary";

type CohortSummaryData = NonNullable<
  NonNullable<GetClosedCohortQuery["cohort"]>["closedCohortSummary"]
>;

interface StateSummaryProps {
  cohortSummaryData: CohortSummaryData;
}

/**
 * State-specific summary component that renders different content
 * based on the cohort's state. This allows for state-specific
 * calculations and displays (e.g., fee calculations for NM).
 */
export function StateSummary({ cohortSummaryData }: StateSummaryProps) {
  const state = cohortSummaryData.state;

  switch (state) {
    case "NM":
      return <NewMexicoSummary cohortSummaryData={cohortSummaryData} />;
    case "CO":
      return <ColoradoSummary cohortSummaryData={cohortSummaryData} />;
    case "KS":
      return (
        <KansasSummary
          facilities={cohortSummaryData.ksFacilityBreakdown ?? []}
        />
      );
    default:
      // No state-specific summary for other states
      return null;
  }
}
